import { ColumnDefWithFilters, ColumnGroup } from '../types'
import { useSimpleColumns } from '../utils'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'

const nonLiveGroups: ColumnGroup[] = [
  {
    id: 'honorable_kills',
    header: 'Honorable Kills',
    subColumns: [
      {
        id: 'total_honorable_kills',
        header: 'Total',
        field: 'honorable_kills',
      },
    ],
  },
  {
    id: 'current_ratings',
    header: 'Current Ratings',
    subColumns: [
      { id: '2v2_current', header: '2v2', field: '2v2_rating' },
      { id: '3v3_current', header: '3v3', field: '3v3_rating' },
      { id: 'rbg_current', header: 'RBG', field: 'rbg_rating' },
    ],
    rankMode: 'max',
    rankFields: ['2v2_rating', '3v3_rating', 'rbg_rating'],
  },
  {
    id: 'highest_ratings',
    header: 'Highest Ever Ratings',
    subColumns: [
      { id: '2v2_max', header: '2v2', field: 'max_2v2_rating' },
      { id: '3v3_max', header: '3v3', field: 'max_3v3_rating' },
    ],
    rankMode: 'max',
    rankFields: ['max_2v2_rating', 'max_3v3_rating'],
  },
  {
    id: 'played_this_season',
    header: 'Played This Season',
    subColumns: [
      { id: '2v2_season', header: '2v2', field: '2v2_season_played' },
      { id: '3v3_season', header: '3v3', field: '3v3_season_played' },
      { id: 'rbg_season', header: 'RBG', field: 'rbg_season_played' },
    ],
    rankFields: ['2v2_season_played', '3v3_season_played', 'rbg_season_played'],
  },
  {
    id: 'played_this_week',
    header: 'Played This Week',
    subColumns: [
      { id: '2v2_week', header: '2v2', field: '2v2_week_played' },
      { id: '3v3_week', header: '3v3', field: '3v3_week_played' },
      { id: 'rbg_week', header: 'RBG', field: 'rbg_week_played' },
    ],
    rankFields: null,
  },
]

export const usePvpColumns = (): ColumnDefWithFilters => {
  const gameVersion = useGameVersion()

  const hasHonorLevel = gameVersion.has('honor_level')

  const collectionGroups: ColumnGroup[] = [
    ...(hasHonorLevel
      ? [
          {
            id: 'honor_level',
            header: 'Honor Level',
            subColumns: [
              {
                id: 'total_honor_level',
                header: 'Total',
                field: 'honor_level',
              },
            ],
          },
        ]
      : []),
    ...nonLiveGroups,
  ]

  const columns = useSimpleColumns(collectionGroups)

  return {
    columns,
    initialSortBy: [
      {
        id: hasHonorLevel ? 'total_honor_level' : 'total_honorable_kills',
        desc: true,
      },
    ],
  }
}
